// Admin Authentication Utilities

export const getAdminToken = () => {
  return localStorage.getItem('adminToken');
};

export const setAdminToken = (token) => {
  localStorage.setItem('adminToken', token);
};

export const setAdminUser = (user) => {
  localStorage.setItem('adminUser', JSON.stringify(user));
};

export const removeAdminToken = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUser');
};

export const getAdminUser = () => {
  const user = localStorage.getItem('adminUser');
  return user ? JSON.parse(user) : null;
};

export const isAdminLoggedIn = () => {
  const token = getAdminToken();
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp > Date.now() / 1000;
  } catch {
    return false;
  }
};

export const getAuthHeaders = () => {
  const token = getAdminToken();
  if (!token) {
    console.warn('⚠️ No admin token found when getting auth headers');
    return {
      'Content-Type': 'application/json'
    };
  }
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const handleAuthError = (error, response) => {
  if (response && response.status === 401) {
    removeAdminToken();
    // Dispatch event instead of reload - AdminPanel will show login form smoothly
    window.dispatchEvent(new CustomEvent('adminLoggedOut'));
  }
  throw error;
};

/**
 * Extract creator ID from createdBy field (handles string, ObjectId, populated object, $oid)
 * Used for team member filtering - products/orders created by current user
 */
export const extractCreatorId = (createdBy) => {
  if (createdBy == null) return null;
  if (typeof createdBy === 'string') return createdBy;
  if (typeof createdBy === 'object') {
    if (createdBy._id) return String(createdBy._id);
    if (createdBy.$oid) return createdBy.$oid;
    if (createdBy.id) return String(createdBy.id);
    if (typeof createdBy.toString === 'function') return createdBy.toString();
  }
  return String(createdBy);
};

/**
 * Get creator display name - uses profile name from localStorage when creator is current user
 * So "Created by" updates when user changes their name in My Account
 */
export const getCreatorDisplayName = (createdBy) => {
  if (!createdBy) return null;
  const creatorId = extractCreatorId(createdBy);
  const adminUser = getAdminUser();
  if (adminUser && creatorId && String(adminUser._id || adminUser.id) === String(creatorId)) {
    return adminUser.name || adminUser.email || null;
  }
  if (typeof createdBy === 'object') {
    if (createdBy.role === 'admin') return 'Super Wear';
    return createdBy.name || createdBy.email || null;
  }
  return null;
};